<template>
  <div>
    <div v-if="specType === 'DIMENSION'" class="row q-col-gutter-md">
      <div class="col-12 col-md-4">
        <q-input
          v-model.number="local.length_cm"
          label="Length (cm)"
          type="number"
          dense
          outlined
        />
      </div>
      <div class="col-12 col-md-4">
        <q-input
          v-model.number="local.width_cm"
          label="Width (cm)"
          type="number"
          dense
          outlined
        />
      </div>
      <div class="col-12 col-md-4">
        <q-input
          v-model.number="local.height_cm"
          label="Height (cm)"
          type="number"
          dense
          outlined
        />
      </div>
    </div>

    <div v-else-if="specType === 'VOLUME'" class="row q-col-gutter-md">
      <div class="col-12 col-md-6">
        <q-input
          v-model.number="local.volume_value"
          label="Volume"
          type="number"
          dense
          outlined
        />
      </div>
      <div class="col-12 col-md-6">
        <q-select
          v-model="local.volume_unit"
          :options="volumeUnits"
          label="Unit"
          dense
          outlined
          emit-value
          map-options
        />
      </div>
    </div>

    <div v-else-if="specType === 'APPAREL_SIZE'" class="row q-col-gutter-md">
      <div class="col-12 col-md-6">
        <q-input
          v-model="local.apparel_size"
          label="Apparel Size"
          dense
          outlined
          placeholder="S / M / L / XL"
        />
      </div>
    </div>

    <div v-else-if="specType === 'PRODUCT_OPTION'" class="row q-col-gutter-md">
      <div class="col-12 col-md-4">
        <q-input
          v-model="local.model_code"
          label="모델코드"
          dense
          outlined
          placeholder="OB362"
        />
      </div>
      <div class="col-12 col-md-4">
        <q-input
          v-model="local.color"
          label="색상"
          dense
          outlined
          placeholder="Chestnut"
        />
      </div>
      <div class="col-12 col-md-4">
        <q-input
          v-model="local.size"
          label="사이즈"
          dense
          outlined
          placeholder="L5 / 36 / M"
        />
      </div>
    </div>

    <div v-else-if="specType === 'PACK_COUNT'" class="row q-col-gutter-md">
      <div class="col-12 col-md-4">
        <q-input
          v-model="local.pack_unit_type_code"
          label="Pack Unit Type Code"
          dense
          outlined
          placeholder="TABLET"
        />
      </div>
      <div class="col-12 col-md-4">
        <q-input
          v-model.number="local.pack_count"
          label="Pack Count"
          type="number"
          dense
          outlined
        />
      </div>
      <div class="col-12 col-md-4">
        <q-input
          v-model="local.pack_uom"
          label="UOM"
          dense
          outlined
          placeholder="ea"
        />
      </div>
    </div>

    <div v-else class="text-caption text-grey">spec_type을 선택하세요.</div>
  </div>
</template>

<script>
export default {
  name: 'SpecTypeForm',
  props: {
    specType: {
      type: String,
      default: ''
    },
    modelValue: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      syncingFromParent: false,
      local: {
        ...this.buildLocalState(this.modelValue),
      },
      volumeUnits: [
        { label: 'ml', value: 'ml' },
        { label: 'L', value: 'L' },
      ]
    }
  },
  methods: {
    buildLocalState(value = {}) {
      return {
        volume_unit: 'ml',
        pack_uom: 'ea',
        ...(value || {}),
      }
    },
    isSameState(a = {}, b = {}) {
      return JSON.stringify(a || {}) === JSON.stringify(b || {})
    }
  },
  watch: {
    modelValue: {
      deep: true,
      immediate: true,
      handler(val) {
        const nextLocal = this.buildLocalState(val)
        if (this.isSameState(this.local, nextLocal)) return
        this.syncingFromParent = true
        this.local = nextLocal
      }
    },
    local: {
      deep: true,
      handler(val) {
        if (this.syncingFromParent) {
          this.syncingFromParent = false
          return
        }
        if (this.isSameState(this.modelValue, val)) return
        this.$emit('update:modelValue', { ...val })
      }
    },
    specType() {
      const nextLocal = this.buildLocalState(this.local)
      if (this.isSameState(this.local, nextLocal)) return
      this.syncingFromParent = true
      this.local = nextLocal
    }
  }
}
</script>
